// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__17KAc","header":"PatientBlock_header__28Zep","label":"PatientBlock_label__1R6sL","option":"PatientBlock_option__3pn4t"};